import { Button, Card, Form, Input } from "antd";
import { useEffect } from "react";
import Loader from "../../../../components/ui/Loader";
import {
  useAddApiTokenMutation,
  useGetApiTokenQuery,
} from "../../../../features/device/deviceApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";

export default function ConfigDeviceApiToken() {
  const [form] = Form.useForm();

  const [addApiToken, { isLoading, isSuccess, isError, error }] =
    useAddApiTokenMutation();
  const {
    data: getApiTokenData,
    isLoading: getApiTokenIsLoading,
    isError: getApiTokenIsError,
    error: getApiTokenError,
  } = useGetApiTokenQuery();

  useError(isError, error, "Add API token fail");
  useError(getApiTokenIsError, getApiTokenError, "Get API token data fail");

  const onFinish = (values: string) => {
    addApiToken({
      data: values,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "API token added successfully!");
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <SidebarLayout title="Config Device API Token">
      {getApiTokenIsLoading ? (
        <Loader />
      ) : (
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <Card>
            <div className="block text-[#2e3541] text-base font-medium mb-3">
              Currently Configured Active API Token:&nbsp;
              <span
                className=" text-blue-600"
                // onClick={() => {
                //   if (getApiTokenData?.data?.api_token) {
                //     navigator.clipboard.writeText(
                //       getApiTokenData.data.api_token
                //     );
                //     toast("success", "API Token copied!");
                //   }
                // }}
              >
                {getApiTokenData?.data?.api_token}
              </span>
            </div>

            <div className="grid md:grid-cols-2 gap-x-4">
              <Form.Item
                name="api_token"
                label="API Token"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter API token",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter API token" allowClear />
              </Form.Item>
            </div>

            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              loading={isLoading}
            >
              Submit
            </Button>
          </Card>
        </Form>
      )}
    </SidebarLayout>
  );
}
